import React, { useState, useLayoutEffect, useRef } from "react";
export default ({ children, wrap }) => {
  const ref = useRef();
  const [checked, setChecked] = useState(false);
  const [empty, setEmpty] = useState(false);
  useLayoutEffect(() => {
    if (!ref.current.childElementCount) {
      setEmpty(true);
    } else {
      setChecked(true);
    }
  }, []);
  if (empty) return null;
  if (checked) {
    return wrap ? <wrap.type {...wrap.props}>
      {wrap.props.children}
      {children}
    </wrap.type> : children;
  }
  //TODO 更好的检测是否有dom子元素
  return <div ref={ref}>{children}</div>;
};
